import { render, staticRenderFns } from "./AppPaidServicesListingBlock.vue?vue&type=template&id=536bbd96&scoped=true"
import script from "./AppPaidServicesListingBlock.vue?vue&type=script&lang=js"
export * from "./AppPaidServicesListingBlock.vue?vue&type=script&lang=js"
import style0 from "./AppPaidServicesListingBlock.vue?vue&type=style&index=0&id=536bbd96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536bbd96",
  null
  
)

export default component.exports